@if (status()?.canUpload) {
	<button
		class="actionButton"
		matTooltipClass="accent"
		[matTooltip]="'Upload to LMS' | translate"
		appStopPropagation
		(click)="upload()"
		[disabled]="isLoading()"
		mat-icon-button
		color="accent"
	>
		<mat-icon fontSet="fad" fontIcon="fa-upload" [class.notUploaded]="!status()?.lastUploaded && !isLoading()" />
	</button>

	@if (status()?.lastUploaded) {
		<button
			class="actionButton"
			matTooltipClass="accent"
			[matTooltip]="'Publish' | translate"
			appStopPropagation
			(click)="publish()"
			[disabled]="isLoading()"
			mat-icon-button
			color="accent"
		>
			<mat-icon fontSet="fad" [fontIcon]="status()?.isPublished ? 'fa-eye' : 'fa-eye-slash'" [class.inactive]="isLoading()" />
		</button>
	}
}
